import { Component, OnInit, Inject, EventEmitter, Pipe, DebugElement } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { utiles } from '@utl/environment';

declare var $: any;


@Component({
  selector: 'app-modal-branch-office',
  templateUrl: './modal-branch-office.component.html',
  styleUrls: ['./modal-branch-office.component.scss']
})
export class ModalBranchOfficeComponent implements OnInit {
  labelTitile: string;
  listSites: any;
  listAddress: any;
  listCustAddress: any;
  listSiteAddress: any;
  selectedListAddress: any;
  SelectedList = 0;
  ShoppingCartId = 0;
  selectedSite: any;
  buttonColor = '#FFF'; //Default Color
  selectAddress = new EventEmitter();
  address: string;

  constructor(
    public dialogRef: MatDialogRef<ModalBranchOfficeComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMessage: any,
  ) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.listAddress = this.dataMessage.listAddress;
      this.listCustAddress = this.dataMessage.listCustAddress;
      this.listSiteAddress = this.dataMessage.listSiteAddress;
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }
  }

  ngOnInit() {
    const addressCache = utiles.getCacheSelectedAddress();
    this.address = addressCache.DeliveryPostalAddressId;
    let orderedArray = [];

    // Se ordenan los elementos de la Lista de direcciones de Cliente
    this.listCustAddress.forEach(element => {
      if (element.AddressId === this.address) {
        orderedArray.push(element);
      }
    });

    this.listCustAddress.forEach(element => {
      if (element.AddressId !== this.address) {
        orderedArray.push(element);
      }
    });

    this.listCustAddress = orderedArray;

    orderedArray = [];
    // Se ordenan los elementos de la Lista de direcciones de Sitio
    this.listSiteAddress.forEach(element => {
      if (element.AddressId === this.address) {
        this.selectedListAddress = 1;
        orderedArray.push(element);
      }
    });

    this.listSiteAddress.forEach(element => {
      if (element.AddressId !== this.address) {
        orderedArray.push(element);
      }
    });

    this.listSiteAddress = orderedArray;
  }

  selectAddressEvent(addressId: string) {
    this.selectAddress.emit(addressId);
    this.dialogRef.close();
  }

  carouselCards() {
    let addressCache = utiles.getCacheSelectedAddress();
    addressCache = addressCache !== null && addressCache !== undefined ? addressCache.DeliveryPostalAddressId : '';
    let that = this;
    $(document).ready(function() {
      $('.carousel.carousel-branchOffice .carousel-item').each(function() {
        let office = $(this);
        if (office[0].firstChild.id === addressCache) {
          office[0].firstChild.className = office[0].firstChild.className + ' activeMode';
        }

        var next = $(this).next();
        if (!next.length) {
          next = $(this).siblings(':first');
        }
        if (next[0].firstChild.id === addressCache) {
          next[0].firstChild.className = next[0].firstChild.className + ' activeMode';
        }

        if (that.listAddress.length <= 1) {

        } else if (that.listAddress.length === 2) {
          next.children(':first-child').clone().appendTo($(this));

          for (var i = 0; i < 0; i++) {
            next = next.next();
            if (!next.length) {
              next = $(this).siblings(':first');
              if (next[0].firstChild.id === addressCache) {
                next[0].firstChild.className = next[0].firstChild.className + ' activeMode';
              }
            }

            next.children(':first-child').clone().appendTo($(this));
          }
        } else if (that.listAddress.length === 3) {
          next.children(':first-child').clone().appendTo($(this));

          for (var i = 0; i < 1; i++) {
            next = next.next();
            if (!next.length) {
              next = $(this).siblings(':first');
            }
            if (next[0].firstChild.id === addressCache) {
              next[0].firstChild.className = next[0].firstChild.className + ' activeMode';
            }
            next.children(':first-child').clone().appendTo($(this));
          }
        } else if (that.listAddress.length >= 4) {
          next.children(':first-child').clone().appendTo($(this));

          for (var i = 0; i < 2; i++) {
            next = next.next();
            if (!next.length) {
              next = $(this).siblings(':first');
            }
            if (next[0].firstChild.id === addressCache) {
              next[0].firstChild.className = next[0].firstChild.className + ' activeMode';
            }
            next.children(':first-child').clone().appendTo($(this));
          }
        }
      });

      $('.branchOfficeClick').click(function() {
        $('.branchOfficeClick').removeClass('activeMode');
        $(this).addClass('activeMode');
      });

      $('.branchOfficeClick').click(function(e) {
        that.selectAddress.emit(e.currentTarget.name);
        that.dialogRef.close();
      });
    });
  }
}
